import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=d0a59dea&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=d0a59dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a59dea",
  null
  
)

export default component.exports